// toDo: initiai states
function signInOTPReducer(state = {}, action) {
  switch (action.type) {
    case 'SEND_LOGIN_OTP':
      let { otpSuccess = false } = action;
      let sendOtpLoginState = { ...state, otpSuccess, otpResponseObj: action.otpResponseObj };
      return sendOtpLoginState;
      break;
    default:
      return state;
  }
}

export default signInOTPReducer;
